import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from '../components/Footer';
import Header from '../components/Header';

const GizlilikIlkeleri = () => {
    return (
        <>
            <Helmet>
                <title>Gizlilik İlkeleri - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Legalbul.com gizlilik ilkeleri." />
            </Helmet>
            
            <Header />
            <section className="container p-5 my-5 bg-white shadow-sm">
                <ol className="breadcrumbnav">
                    <li>
                        <Link to="/">Ana Sayfa</Link>
                    </li>
                    <li>
                        Gizlilik İlkeleri
                    </li>
                </ol>
                <div>
                    <h1>SSL Güvenliği</h1>
                    Sitemiz, güvenli iletişim için SSL (Güvenli Yuva Katmanı) sertifikası kullanmaktadır. Bu, ziyaretçilerimizin
                    kişisel bilgilerinin şifrelenmiş bir şekilde iletilmesini sağlar ve sitemizin güvenliğini artırır.
                </div>
                <div className="py-4">
                    <h3 className="py-1">Toplanan Bilgiler</h3>
                    <div>
                        Legalbul.com'u ziyaret ettiğinizde, sizden kişisel olarak tanımlanabilen bilgileri
                        toplamıyoruz. Ancak, sitemizi kullanırken sunucularımız otomatik olarak belirli bilgileri kaydedebilir.
                    </div>
                </div>
                <div className="py-4">
                    <h3 className="py-1">Harici Bağlantılar</h3>
                    <div>
                        Sitemiz, üçüncü taraf web sitelerine bağlantılar içerebilir. Ancak, bu harici sitelerin gizlilik
                        uygulamalarıyla ilgili herhangi bir kontrolümüz yoktur. Bu nedenle, bu siteleri ziyaret ettiğinizde
                        kendi gizlilik politikalarını gözden geçirmeniz önerilir.
                    </div>
                </div>
                <div className="py-4">
                    <h3 className="py-1">İletişim</h3>
                    <div>
                        Gizlilik ilkesi ile ilgili herhangi bir sorunuz veya endişeniz varsa, lütfen bize ulaşın:
                        iletisim@legalbul.com
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default React.memo(GizlilikIlkeleri);
